import { render, staticRenderFns } from "./Animales.vue?vue&type=template&id=4083d3b2&scoped=true&"
import script from "./Animales.vue?vue&type=script&lang=js&"
export * from "./Animales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083d3b2",
  null
  
)

export default component.exports